"use client";

import dynamic from "next/dynamic";
import React from "react";
import type { Nullable } from "../../../@types/generic";
import { useTrackingParameter } from "../../../app/(dach)/hooks";
import { useCountry } from "../../../hooks/useCountry";
import type { ProgrammaticFrameworks } from "../types";
import { GeoEdge } from "./GeoEdge";
import { GoogleInterstitial } from "./GoogleInterstitial";
import { Taboola } from "./Taboola";
import { TeAds } from "./TeAds";

const ClickPerformanceATCH = dynamic(
    () =>
        import("./ClickPerformanceATCH").then(
            (mod) => mod.ClickPerformanceATCH
        ),
    { ssr: false }
);

const ClickPerformanceDE = dynamic(
    () => import("./ClickPerformanceDE").then((mod) => mod.ClickPerformanceDE),
    { ssr: false }
);

const Som = dynamic(() => import("./Som").then((mod) => mod.Som), {
    ssr: false,
});

type Props = {
    enabledFrameworks: Nullable<Array<ProgrammaticFrameworks>>;
};

export const AdScripts: React.FC<Props> = ({ enabledFrameworks }: Props) => {
    const country = useCountry();
    const trackingParameter = useTrackingParameter();

    if (enabledFrameworks === null) {
        return null;
    }

    const isTrackingParameterReady = trackingParameter !== undefined;

    return (
        <>
            {enabledFrameworks.includes("CP_AT") && country === "at" ? (
                <ClickPerformanceATCH trackingParameter={trackingParameter} />
            ) : null}
            {enabledFrameworks.includes("CP_CH") && country === "ch" ? (
                <ClickPerformanceATCH trackingParameter={trackingParameter} />
            ) : null}
            {enabledFrameworks.includes("CP_DE") && country === "de" ? (
                <ClickPerformanceDE trackingParameter={trackingParameter} />
            ) : null}
            {isTrackingParameterReady ? (
                <>
                    {enabledFrameworks.includes("googleInterstitial") ? (
                        <GoogleInterstitial />
                    ) : null}
                    {enabledFrameworks.includes("geoedge") ? <GeoEdge /> : null}
                    {enabledFrameworks.includes("teads") ? <TeAds /> : null}
                    {enabledFrameworks.includes("SOM") && country === "at" ? (
                        <Som trackingParameter={trackingParameter} />
                    ) : null}
                    {enabledFrameworks.includes("taboola") ? <Taboola /> : null}
                </>
            ) : null}
        </>
    );
};
